import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'ContentEndLevelPopupLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '05010f98-1625-496a-859f-8d4933433706',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '280699fb-d598-46e8-9ddd-c56b604573e7',
      type: 'Container',
      name: 'mainContent',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '9d0fe167-b997-4aa2-aca8-f6c96afd16c4',
      type: 'Container',
      name: 'AnimationContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '44fd6f74-7b80-4461-b77c-ea48918b549d',
      type: 'Text',
      name: 'PurchaseCompleteText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassPremiumUnlocked',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: [
          '#ffff3f',
          '#f58e48'
        ],
        fillGradientStops: [
          0.7,
          0
        ],
        stroke: '#981515',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 89.6,
        dropShadowBlur: 0,
        dropShadowColor: '#981515',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassPurchaseComplete {
  static raw = raw;
  root: PIXI.Container
  mainContent: PIXI.Container
  AnimationContainer: PIXI.Container
  PurchaseCompleteText: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
